import { usePerfis } from "../../lib/cadastros/hooks";
import { ErroHttp } from "../../lib/http/erros";

/*
 * Página de Perfis do módulo de Cadastros (FE-4 CP-C).
 *
 * READ-ONLY: `GET /api/perfis` (ação `gerenciar_usuarios`) lista os perfis de
 * acesso (id, nome). Não há criar/editar/excluir — sem formulário, sem mutação.
 * A aba é gated por `gerenciar_usuarios` no layout.
 *
 * Estados loading/erro/vazio claros, espelhando as demais páginas do módulo.
 * SÓ classes Tailwind dos tokens CPMH.
 */

export function PaginaPerfis(): JSX.Element {
  const consulta = usePerfis();

  if (consulta.isPending) {
    return (
      <p className="font-corpo text-base text-off-black">Carregando perfis…</p>
    );
  }

  if (consulta.isError) {
    const mensagem =
      consulta.error instanceof ErroHttp
        ? consulta.error.message
        : "Não foi possível carregar os perfis.";
    return (
      <p role="alert" className="font-corpo text-base text-flame">
        {mensagem}
      </p>
    );
  }

  const perfis = consulta.data;

  if (perfis.length === 0) {
    return (
      <p className="font-corpo text-base text-off-black">
        Nenhum perfil cadastrado.
      </p>
    );
  }

  return (
    <table className="w-full border-collapse font-corpo text-base text-off-black">
      <thead>
        <tr className="border-b border-platinum text-left">
          <th className="py-2 pr-4 font-subtitulo">Nome</th>
        </tr>
      </thead>
      <tbody>
        {perfis.map((perfil) => (
          <tr key={perfil.id} className="border-b border-platinum">
            <td className="py-2 pr-4">{perfil.nome}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
